import { dateFormat, decryptedValue } from "common/utility";
import { allFinancier, getOneDeal } from "http/fundLync/deal.helper";
import { callGetFinancier } from "http/fundLync/dealFinancier";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { FaCalendarAlt } from "react-icons/fa";
import { Button, Container, Row, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";

const AppliedLoans = () => {
  const [loading, setLoading] = useState(false);
  const [loanAmounts, setLoanAmounts] = useState([]);
  const [rateOfInterests, setRateOfInterests] = useState([]);
  const [applicationId, setApplicationId] = useState([]);
  const [financierList1, setFinancierList1] = useState([])
  const [rejectedIds, setRejectedIds] = useState([]);
  const [acceptedIds, setAcceptedIds] = useState([]);
  const [dealDetails, setDealDetails] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const urlParams = new URLSearchParams(window.location.search);
  const user = decryptedValue(localStorage.getItem("user"));
  const encodedDealId = urlParams.get("dealId");
  const dealId = atob(encodedDealId);
  const query = urlParams.get("query");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDealDetails = async () => {
      try {
        const response = await getOneDeal({ id: dealId });
        if (response) {
          setDealDetails(response);
        }
      } catch (error) {
        console.error("Error fetching deal details:", error);
      }
    };
    fetchDealDetails();
    handleShowFinanciers(dealId)
  }, [])

  const handleActionRejected = (id) => {
    setRejectedIds((prev) => [...prev, id]);
  };

  const formatNumberWithCommas = (number) => {
    if (!dealDetails || dealDetails.length === 0) {
      return <div>Loading...</div>;
    }
    const formattedNumber = number?.toString().replace(/\./, ',');
    const parts = formattedNumber?.split(',');
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return parts.join(',');
  };

  const removeSpaces = (name) => {
    return name.replace(/\s+/g, '');
  }

  const handleShowFinanciers = (id) => {
    callGetFinancier({ dealId: id })
      .then(async (response) => {
        if (response.code == 200 && response.status) {
          const financiersData = response?.data.rows || [];

          let filteredFinanciers = [];

          if (query === "Accepted") {
            filteredFinanciers = financiersData.filter((ele) => ele.isAccepted);
          } else if (query === "Interested") {
            filteredFinanciers = financiersData.filter(
              (ele) => ele.isInterested || ele.status === 3
            );
          } else if (query === "Rejected") {
            filteredFinanciers = financiersData.filter((ele) => ele.isRejected);
          } else {
            filteredFinanciers = financiersData;
          }

          if (filteredFinanciers.length > 0) {
            setFinancierList1(filteredFinanciers);
          } else {
            setFinancierList1([]);
          }

          let financiersList = await allFinancier({ user });
          if (financiersList) {
            financiersList = financiersList.data;
          }

        } else {
          setFinancierList1([]);
          allFinancier({ user })
            .then((response) => {
              if (response.code == 200 && response.status) {
                setFinancierList(response?.data);
              }
            })
            .catch((error) => { });
        }
      })
      .catch((error) => { });

  };
  const toggleAccept = async (id, loanAmount, rateOfInterest, tenure, applicationId) => {
    setLoading(true)
    setLoadingStates((prev) => ({ ...prev, [id]: true }));

    const encryptedDealId = btoa(dealId.toString());

    setTimeout(() => {
      setAcceptedIds((prev) => [...prev, id]); // Mark as accepted
      navigate(`/${user.roleName}/entity/deal-accept?dealId=${encryptedDealId}&amount=${loanAmount}&rate=${rateOfInterest}&tenure=${tenure}&applicationId=${applicationId}`);

      setLoadingStates((prev) => ({ ...prev, [id]: false }));
      setLoading(false);
    }, 3000);
  };

  const generateDistinctRandomizedValues = (originalValue, count) => {
    const values = new Set();
    while (values.size < count) {
      const percentage = Math.random() * (10 - 5) + 5; // Random percentage between 5% and 10%
      const randomizedValue = Math.round((originalValue * (1 - percentage / 100)) / 1000) * 1000;
      values.add(randomizedValue);
    }
    return Array.from(values);
  };

  const randomizedValues = generateDistinctRandomizedValues(dealDetails?.loanRequirement, financierList1.length)
  const generateRandomRateOfInterest = () => {
    return (Math.random() * (15 - 1) + 1).toFixed(2);
  }

  const generateRandomApplicationNumber = () => {
    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    const date = new Date();
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${date.getFullYear()}`;
    const applicationNumber = `${randomNumber}-${formattedDate}`;
    return applicationNumber;
  };


  useEffect(() => {
    const loanAmounts = financierList1.map((charge, index) => formatNumberWithCommas(randomizedValues[index]));
    const rateOfInterests = financierList1.map(() => generateRandomRateOfInterest());
    const applicationId = financierList1.map(() => generateRandomApplicationNumber());
    setLoanAmounts(loanAmounts);
    setRateOfInterests(rateOfInterests);
    setApplicationId(applicationId);
  }, [financierList1]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="vertical-scroll">
            <Row className="entityRow" >
              <h5>{query} Financiers</h5>
              <div className='mb-4' >
                <div
                  className="application-card bg-white"
                  style={{
                    overflowX: isMobile ? "auto" : "unset",
                  }}
                >
                  <div
                    className="d-flex non-personal"
                    style={{
                      minWidth: isMobile ? "900px" : "unset",
                    }}
                  >
                    <div className="heading-column application-id">Application Id</div>
                    <div className="heading-column financer-name">Financer Name</div>
                    <div className="heading-column loan-amount">Offered Amount</div>
                    <div className="heading-column interest-rate">Interest Rate</div>
                    <div className="heading-column tenure">Tenure</div>
                  </div>
                  {financierList1.length > 0 ? (
                    financierList1.map((charge, index) => {
                      const loanAmount = loanAmounts[index];
                      const rateOfInterest = rateOfInterests[index];
                      const tenure = dealDetails?.tenure;
                      const application = applicationId[index];
                      return (
                        <div
                          key={index} className="loan-card">
                          <div
                            className="d-flex"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="data-item">{application}</div>
                            <div className="data-item">

                              <img src={`https://logo.clearbit.com/${removeSpaces(charge.financier.entityName)}.com` || `${charge.financier.entityName}`} alt="Loan Provider Logo" className="loan-logo" />

                            </div>
                            <div className="data-item">
                              ₹ {(loanAmount)}
                            </div>
                            <div className="data-item">
                              {`${rateOfInterest} %`}
                            </div>
                            <div className="data-item">{dealDetails?.tenure}</div>

                          </div>
                          <div
                            style={{
                              borderTop: "1.5px dashed #E0E0E0",
                              margin: "8px 0",
                            }}
                          ></div>
                          <div className="d-flex align-items-center" >
                            <div
                              style={{
                                width: "20%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              <FaCalendarAlt className="text-loan-primary"
                              />
                              {<span style={{ fontSize: "0.8rem" }} className='text-loan-primary'>
                                Offer-Date: {dateFormat(charge.interestedAt, 'DD/MM/yyyy')}
                              </span>}
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "10px",
                              }}
                              className='d-flex justify-content-end'
                            >
                              <>
                                {!charge.isAccepted && !charge.isRejected && !rejectedIds.includes(charge.id) && !acceptedIds.includes(charge.id) &&
                                  <div>
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded me-2 mt-2"
                                      style={{ padding: "4px 10px" }}
                                      outline
                                    >
                                      Sanctioned
                                    </Button>
                                    <Button
                                      type="button"
                                      color="danger"
                                      className="btn-rej-primary me-2 mt-2"
                                      onClick={() => handleActionRejected(charge.id)}
                                    >
                                      Reject
                                    </Button>
                                    <Button
                                      key={charge.id}
                                      type="button"
                                      color="success"
                                      className="me-2 mt-2"
                                      onClick={() => toggleAccept(charge.id, loanAmount, rateOfInterest, tenure, application)}
                                      disabled={loadingStates[charge.id]}
                                    >
                                      {loadingStates[charge.id] ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <Spinner className="spinner" size="sm" />
                                          <span> Accepting...</span>
                                        </div>
                                      ) : (
                                        'Accept'
                                      )}
                                    </Button>

                                  </div>
                                }
                                {
                                  charge.isAccepted && <div>
                                    <Button type="button"
                                      color="success" className="btn me-2 mt-2 font-size-12"
                                      style={{ padding: "4px 10px" }}>Offer Accepted</Button>
                                  </div>
                                }
                                {
                                  rejectedIds.includes(charge.id) && (
                                    <div>
                                      <Button
                                        type="button"
                                        color="danger"
                                        className="btn me-2 mt-2 font-size-12"
                                        style={{ padding: "4px 10px" }}
                                      >
                                        Offer Rejected
                                      </Button>
                                    </div>
                                  )
                                }
                              </>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div className='outerCongrats'>
                      <div style={{ padding: "50px" }}>
                        <p className="text-center no-data-found">
                          No {query} FInanciers data found
                        </p></div>
                    </div>
                  )}
                </div>
              </div>
            </Row>
          </div>
        </Container>
      </div>
      {loading && (
        <div className='spinnerstatic'>
          <Spinner animation="border" role="status" variant="light">
            <span >Accepting ...</span>
          </Spinner>
        </div>
      )}
    </React.Fragment>
  );
};

export default AppliedLoans;
